import React from "react";
import { IconProps } from "./dto";

export function InactiveIcon() {
    return (
        <svg width= "10" height = "6" viewBox = "0 0 10 6" fill = "none" style={{margin:'auto'}}>
            <circle cx="5" cy = "3" r = "3" fill = "#FF443D" />
        </svg>
    )
}